import { z } from "zod";
import { BalanceSheetAccountClass } from "../../constants/domains/accounting/accounts";

export const BalanceSheetAccountSchema = z.object({
    name: z.string().max(500),
    balance: z.number().finite().nullable(),
    classification: z.nativeEnum(BalanceSheetAccountClass).nullable(),
});

export const BalanceSheetExtractionSchema = z.object({
    accounts: z.array(BalanceSheetAccountSchema).max(500),
    date: z.string().date().nullable(),
    warnings: z.array(z.string().max(500)).max(50),
});

export type BalanceSheetAccount = z.infer<typeof BalanceSheetAccountSchema>;
export type BalanceSheetExtraction = z.infer<
    typeof BalanceSheetExtractionSchema
>;
